<template>
  <div>
    <v-dialog
      persistent
      v-model="value"
      scrollable
      max-width="350px"
    >
      <v-card>
        <v-container
          fluid
        >
          <v-layout
            wrap
            row
          >
            <v-flex
              xs12
              class="centerContent"
              style="text-align: center"
            >
              <div class="message">
                {{ message }}                
              </div>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            row
            class="mt-3"
          >
            <v-flex
              xs6
              class="centerContent"
            >
              <v-btn
                small
                color="primary"
                dark
                @click="close"
              >
                Cancelar
              </v-btn>
            </v-flex>

            <v-flex
              xs6
              class="centerContent"
            >
              <v-btn
                small
                color="primary"
                dark
                @click="save"
              >
                Confirmar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import 'vue2-timepicker/dist/VueTimepicker.css';
export default {
    components: {
    },
    props: ["value", "message"],
    data: () => ({
    
    }),
    watch: {
    },
    methods: {
        close() {
          this.$emit("input", false)
        },
        save(){
          this.$emit("input", false)
          this.$emit("save")
          // const body = {
          //   course: {
          //     id: this.workshop.id
          //   },
          //   student: {
          //     id: this.student.id
          //   }
          // }
          // if (this.isEnrolled){
          //   this.$store
          //     .dispatch("workshop/enrolledStudent", body)
          //     .then((response) => {
          //       if(response.data.code === 200){
          //         this.close()
          //         this.$emit("reload", true)
          //       }
          //     })
          //     .catch(error => {
          //       console.log(error);
          //     });
          // }else {
          //   this.$store
          //     .dispatch("workshop/disenrollStudent", body)
          //     .then((response) => {
          //       if(response.data.code === 200){
          //         this.close()
          //         this.$emit("reload", true)
          //       }
          //     })
          //     .catch(error => {
          //       console.log(error);
          //     });
          // }
        },
        getMessage(){
          if (this.student && this.workshop){
            return "¿Quieren inscribir a " + this.student.firstName + " al taller de " + this.workshop.name + "?"
          } 
          return ""
        }
    }

};
</script>

<style scoped>

.message {
    font-size: large;
    color: black;

}
</style>